import React, { useEffect, useState } from "react";
import { imgBaseUrl } from "../../api/api";
import { formatToDate } from "../master/FormatToDateTime";

export default function StudentIdCard2({ data, batch }) {
    const [setting, setSetting] = useState({});

    useEffect(() => {
        setSetting(JSON.parse(localStorage.getItem("setting") ?? "{}"));
    }, []);

    const student = data?.student_info ?? {};

    return (
        <>
            <style>{`

                .sid-wrap {
                    display: flex;
                    justify-content: center;
                    align-items: flex-start;
                    padding: 2rem;
                    font-family: 'Barlow', sans-serif;
                    background: #eef0f4;
                    min-height: 100vh;
                    
                }

                .sid-card {
                    border-radius: 18px;
                    overflow: hidden;
                    box-shadow: 0 16px 48px rgba(0,0,0,0.18), 0 2px 8px rgba(0,0,0,0.08);
                    background: #ffffff;
                    border: 1px solid #dde0e8;
                    width: 65mm !important;
  height: 95mm !important;
                }

                /* ══ HEADER ══ */
                .sid-topbar {
                    background: linear-gradient(120deg, #0d2b55 0%, #1a4a8a 100%);
                    padding: 10px 12px 8px;
                    display: flex;
                    align-items: center;
                    gap: 12px;
                    position: relative;
                    overflow: hidden;
                }
                /* decorative circle bg */
                .sid-topbar::before {
                    content: '';
                    position: absolute;
                    top: -30px; right: -30px;
                    width: 110px; height: 110px;
                    border-radius: 50%;
                    background: rgba(244,124,32,0.15);
                }
                .sid-topbar::after {
                    content: '';
                    position: absolute;
                    bottom: -40px; left: 60px;
                    width: 90px; height: 90px;
                    border-radius: 50%;
                    background: rgba(255,255,255,0.05);
                }

                /* Circular logo — LEFT */
                .sid-logo-circle {
                    width: 50px;
                    height: 50px;
                    border-radius: 50%;
                    background: #fff;
                    border: 2px solid rgba(244,124,32,0.8);
                    box-shadow: 0 4px 14px rgba(0,0,0,0.25);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-shrink: 0;
                    padding: 5px;
                    position: relative;
                    z-index: 2;
                }
                .sid-logo-circle img {
                    width: 100%;
                    height: 100%;
                    object-fit: contain;

                    border-radius: 50%;
                }

                /* Divider line between logo and details */
                .sid-header-divider {
                    width: 1.5px;
                    height: 52px;
                    background: rgba(255,255,255,0.25);
                    flex-shrink: 0;
                    border-radius: 2px;
                    position: relative;
                    z-index: 2;
                }

                /* Institute details — RIGHT */
                .sid-inst-details {
                    flex: 1;
                    overflow: hidden;
                    position: relative;
                    z-index: 2;
                }
                .sid-inst-name {
                    font-family: 'Barlow Condensed', sans-serif;
                    font-size: 16px;
                    font-weight: 900;
                    color: #ffffff;
                    margin: 0 0 4px;
                    line-height: 1.2;
                    text-transform: uppercase;
                    letter-spacing: 0.4px;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                }
                .sid-inst-addr {
                    font-size: 9.5px;
                    color: rgba(255,255,255,0.75);
                    margin: 0;
                    line-height: 1.6;
                    display: -webkit-box;
                    -webkit-line-clamp: 3;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                }

                /* Orange bottom strip on header */
                .sid-header-strip {
                    height: 3px;
                    background: linear-gradient(90deg, #f47c20, #ffb347, #f47c20);
                }

                /* ── Photo centered ── */
                .sid-photo-section {
                    display: flex;
                    justify-content: center;
                    padding: 5px 0 10px;
                    background: #fff;
                }
                .sid-photo-frame {
                    width: 70px;
                    height: 80px;
                    border-radius: 10px;
                    border: 1.5px solid #1a3a6b;
                    overflow: hidden;
                    box-shadow: 0 4px 14px rgba(26,58,107,0.20);
                    background: #dce3ed;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
                .sid-photo-frame img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    display: block;
                }



                /* ── Fields ── */
                .sid-fields {
                    padding: 0px 16px 4px;
                }
                .sid-admit-date {
                    font-size: 6.5px;
                    font-weight: 700;
                    color: #1a3a6b;
                    background: #eef3ff;
                    border-left: 3px solid #f47c20;
                    border-radius: 0 6px 6px 0;
                    padding: 1px 10px;
                    margin-bottom: 8px;
                }
                .sid-field-row {
                    display: grid;
                    grid-template-columns: 84px 10px 1fr;
                    font-size: 7px;
                    padding: 3px 0;
                    align-items: baseline;
                    border-bottom: 1px solid #f3f3f3;
                }
                .sid-field-row:last-child { border-bottom: none; }
                .sid-label { font-weight: 500; color: #777; white-space: nowrap; }
                .sid-colon { color: #ccc; }
                .sid-value { font-weight: 700; color: #111; word-break: break-word; line-height: 1.35; }

                /* ── Signature ── */
                .sid-signature {
                    text-align: right;
                    padding: 0px 16px 10px;
                    border-top: 0px dashed #e8ebf2;
                    margin-top: 0px;
                }
                .sid-signature img { height: 15px; display: inline-block; opacity: 0.85; }
                .sid-signature p { font-size: 5px; color: #999; margin: 1px 0 0; font-style: italic; }

                /* ── Footer ── */
                .sid-footer {
                    background: linear-gradient(120deg, #0d2b55 0%, #1a4a8a 100%);
                    padding: 3px 16px 13px;
                }
                .sid-footer-name {
                    font-family: 'Barlow Condensed', sans-serif;
                    font-size: 10px;
                    font-weight: 900;
                    color: #fff;
                    text-align: center;
                    letter-spacing: 0.6px;
                    text-transform: uppercase;
                    line-height: 1.0;
                    margin-bottom: 5px;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                }
                .sid-footer-rule {
                    width: 100%;
                    height: 1.1px;
                    background: linear-gradient(90deg, transparent, #f47c20 30%, #f47c20 70%, transparent);
                    margin-bottom: 6px;
                }
                .sid-footer-addr {
                    text-align: center;
                    font-size: 6.5px;
                    color: rgba(255,255,255,0.78);
                    line-height: 1.65;
                }

                @media print {
                    .sid-wrap { padding: 0; background: none; min-height: auto; }
                    .sid-card { box-shadow: none; }
                }
            `}</style>

            <div className="sid-card ">

                {/* ══ HEADER: circular logo left | details right ══ */}
                <div className="sid-topbar">
                    <div className="sid-logo-circle">
                        <img src={imgBaseUrl + setting?.logo_img} alt="logo" />
                    </div>
                    <div className="sid-header-divider" />
                    <div className="sid-inst-details">
                        <p className="sid-inst-name">{setting?.name ?? ''}</p>
                        <p className="sid-inst-addr">
                            ISO Code: {setting?.iso_code ?? '9001 : 2015'}
                            <br />
                            Mo.: {setting?.mobile || ""}
                        </p>
                    </div>
                </div>
                <div className="sid-header-strip" />

                {/* ── Student photo centered ── */}
                <div className="sid-photo-section">
                    <div className="sid-photo-frame">
                        <img
                            src={student?.profile_picture
                                ? imgBaseUrl + student.profile_picture
                                : "/files/user.png"}
                            alt="Student"
                        />
                    </div>
                </div>


                {/* ── Fields ── */}
                <div className="sid-fields">
                    <div className="sid-admit-date text-center">
                        Admission Date &nbsp;:&nbsp; {formatToDate(student?.admission_date)}
                    </div>
                    {[
                        ["Registration No", student?.registration_no],
                        ["Name", student?.name],
                        ["Father's Name", student?.father_name],
                        ["Mobile No", student?.phone],
                        ["Address", [student?.village, student?.zipcode].filter(Boolean).join(", ")],
                    ].map(([label, value]) => (
                        <div className="sid-field-row" key={label}>
                            <span className="sid-label">{label}</span>
                            <span className="sid-colon">:</span>
                            <span className="sid-value">{value || "—"}</span>
                        </div>
                    ))}
                </div>

                {/* ── Auth Signature ── */}
                <div className="sid-signature">
                    <img src={imgBaseUrl + setting?.signature} alt="" />
                    <p>Auth. Signature</p>
                </div>

                {/* ── Footer ── */}
                <div className="sid-footer">
                    <div className="sid-footer-name">{setting?.tag_line ?? ''}</div>
                    <div className="sid-footer-rule" />
                    <div className="sid-footer-addr">
                        {[setting?.village, setting?.district, setting?.state].filter(Boolean).join(", ")}
                    </div>
                </div>

            </div>

        </>
    );
}